"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M5.5346 21.8992l6.4656-3.2375 6.4656 3.2375-1.081-7.1496 5.077-5.1488-7.1337-1.1812L12.0002 2 8.6723 8.4196 1.5386 9.6008l5.077 5.1488-1.081 7.1496zm10.3769-3.5157l-3.9113-1.9585-3.9113 1.9585.654-4.3251-3.0714-3.1147 4.3155-.7146 2.0132-3.8834 2.0132 3.8834 4.3154.7146-3.0713 3.1147.654 4.3251z",
  clipRule: "evenodd"
})), 'StarIcon');
/* eslint-enable */


exports["default"] = _default;